import { Text } from '@mantine/core';
import { Icon } from '@dealstack/frontend/shared/components/fundament/Icon/Icon';
import { useTranslationCapChart } from '@dealstack/frontend/shared/mechanism/i18n/i18nHooks.tsx';
import {
	CapMenu,
	StyledCapMenuItem,
} from '@dealstack/frontend/app/pages/Project/Cap/CapTablePage/common/CapMenu.tsx';
import { TEST_ELEMENT_IDS } from '@dealstack/shared/tests/testElementIds.ts';

interface Props {
	options: {
		onClick: () => void;
		isLoading?: boolean;
		label: string;
		dataTestId?: string;
	}[];
	isDisabled?: boolean;
}

export const CapExportMenu = ({ options, isDisabled }: Props) => {
	const tCapChart = useTranslationCapChart();

	return (
		<CapMenu
			buttonTargetLabel={tCapChart('buttons.export_label')}
			isDisabled={isDisabled}
			buttonTargetIcon={<Icon variant="download-v3" size="lg" />}
			dataTestId={TEST_ELEMENT_IDS.CAP_TABLE_EXPORT_MENU_BUTTON}
		>
			{options?.map((option) => (
				<StyledCapMenuItem
					key={option.label}
					p="0.5rem"
					leftSection={<Icon variant="download-v3" size="lg" />}
					disabled={option.isLoading}
					onClick={option.onClick}
					data-testid={option.dataTestId}
				>
					<Text size="B6Medium">{option.label}</Text>
				</StyledCapMenuItem>
			))}
		</CapMenu>
	);
};
